import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
const STORAGE_KEY = "elm-panier";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (product) => {
    setItems((prev) => {
      if (prev.some((i) => i.id === product.id)) {
        toast.info("Cette pièce unique est déjà dans votre panier");
        return prev;
      }
      toast.success(`${product.nom} rejoint votre panier`);
      return [...prev, { id: product.id, nom: product.nom, numero: product.numero, prix: product.prix, peau: product.peau, forme: product.forme, diametre: product.diametre, image: product.image || null, couleur_peau: product.couleur_peau, couleur_bois: product.couleur_bois }];
    });
  };

  const removeItem = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const clear = () => setItems([]);

  const value = useMemo(
    () => ({
      items,
      addItem,
      removeItem,
      clear,
      count: items.length,
      total: items.reduce((sum, i) => sum + i.prix, 0),
    }),
    [items]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export const useCart = () => useContext(CartContext);
